import { useTranslation } from 'react-i18next';

import { ContentLayout } from '../../layout/ContentLayout';
import PageMetatags from '../../layout/PageMetatags';
import UserOverviewCard from './UserOverviewCard';

const AnnouncementOverviewPage = () => {
  const { t } = useTranslation();

  return (
    <ContentLayout>
      <PageMetatags title={t('pages:user.meta.title')} />
      <UserOverviewCard />
    </ContentLayout>
  );
};

export default AnnouncementOverviewPage;
